import { EventSourceHandler } from '@sellsy/sse';

export default class CompanyEnrichmentFinishedEventSourceHandler extends EventSourceHandler {
    
    constructor(){
        super()
        this.type = 'staff.companyenrichment.finished'
    }

    handle(event){
        window.EventBus.$emit('dataenrichment:ready', {"data" : event.data});
    }

}